<template>
  <div>
    <div style="display:flex;">
      <div class="right">
        <div class="" style="">
          <el-form
            label-width="150px"
            style="background-color: #fff; padding:0 20px 0 20px;width: 100%;height: 350px;"
            ref="dataFormRef"
            label-position="left"
          >
            <!--< el-form-item label="店铺id：">
                <el-input v-model="swift_data.merchant_id"> </el-input>
              </el-form-item> -->

            <!-- <el-form-item label="搜索信息：">
                <el-input
                  placeholder="威富通商户号:密码"
                  size="small"
                  v-model="searchVlaue"
                >
                  <template slot="append"
                    ><el-button
                      @click="search"
                      slot="append"
                      icon="el-icon-search"
                    ></el-button
                  ></template>
                </el-input>
              </el-form-item> -->

            <el-form-item label="店铺类型：">
              <template>
                <el-radio v-model="swift_data.mch_type" label="1"
                  >付费商户</el-radio
                >
                <el-radio v-model="swift_data.mch_type" label="0"
                  >免费商户</el-radio
                >
              </template>
              <!-- <el-switch
                  v-model="swift_data.mch_type"
                  active-text="付费商户"
                  inactive-text="免费商户"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch> -->
            </el-form-item>
            <el-form-item label="威富通店铺号：">
              <el-input
                v-model="swift_data.mch_no"
                placeholder="请输入威富通店铺号"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="店铺密码：">
              <el-input
                v-model="swift_data.pass_word"
                show-password
                placeholder="请输入店铺密码"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="店铺名称：">
              <el-input
                v-model="swift_data.mch_name"
                placeholder="请输入店铺名称"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="店铺简称：">
              <el-input
                v-model="swift_data.sub_name"
                placeholder="请输入店铺简称"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="支付密钥：">
              <!-- <el-input
                v-model="swift_data.md5"
                show-password
                placeholder="请输入支付密钥"
              >
              </el-input> -->

              <el-input
                type="textarea"
                :rows="4"
                resize="none"
                style="width:250px"
                v-model="swift_data.md5"
                placeholder="请输入支付密钥"
              ></el-input>
            </el-form-item>

            <el-form-item label="威富通商户公钥" prop="detail">
              <el-input
                type="textarea"
                :rows="4"
                resize="none"
                style="width:250px"
                v-model="swift_data.public_key"
                placeholder="请输入店铺公钥"
              ></el-input>
            </el-form-item>
            <el-form-item label="威富通商户私钥：" prop="detail">
              <el-input
                type="textarea"
                :rows="8"
                style="width:250px"
                resize="none"
                v-model="swift_data.private_key"
                placeholder="请输入店铺私钥"
              ></el-input>
            </el-form-item>
            <el-form-item label="店铺备注：">
              <el-input
                v-model="swift_data.remark"
                placeholder="请输入店铺备注"
              >
              </el-input>
            </el-form-item>
            <div style="height:20px"></div>
          </el-form>
        </div>
      </div>
    </div>

    <div class="wty-footer" v-if="who != 'service'">
      <el-button type="success" @click="saveSwiftConfigure">
        保存
      </el-button>
      <el-button type="primary" @click="modifySwift">
        修改
      </el-button>
    </div>
  </div>
</template>
<script>
import { swiftConfigure, swiftQuery, swiftModify } from "@/api/v2/swiftpass.js";
export default {
  props: ["who"],
  data() {
    return {
      mch_no: "", //用来搜索的威富通商户号
      searchVlaue: "", //搜索的值
      swift_data: {
        md5: "",
        mch_no: "",
        sub_name: "",
        pass_word: "",
        mch_name: "",
        private_key: "", //私钥
        public_key: "", //公钥
        /**
         * @type {1|0} mch_type 1-收费商户 0-免费商户
         */
        mch_type: "1",
        remark: "" //备注
      }
    };
  },

  computed: {},
  // components: { uploadImg },
  async mounted() {},
  methods: {
    flush() {
      this.swift_data = {
        md5: "",
        mch_no: "",
        sub_name: "",
        pass_word: "",
        mch_name: "",
        private_key: "", //私钥
        public_key: "", //公钥
        /**
         * @type {1|0} mch_type 1-收费商户 0-免费商户
         */
        mch_type: "1",
        remark: "" //备注
      };
      this.successMessage("新建完成");
    },
    async search() {
      let mch_no = "";
      let pass_word = "";
      if (this.searchVlaue && this.searchVlaue.split(":").length == 2) {
        mch_no = this.searchVlaue.split(":")[0];
        pass_word = this.searchVlaue.split(":")[1];
      }
      this.searchSwiftInfo(mch_no, pass_word);
    },

    async searchSwiftInfo(mch_no, pass_word) {
      // if(this.searchVlaue==""||this.searchVlaue.length==0){
      this.searchVlaue = `${mch_no}:${pass_word}`;
      const ps = await this.$encrypt(this.$md5(pass_word).toUpperCase());
      const res = await swiftQuery(mch_no, ps);
      if (
        res.data.return_code == "SUCCESS" &&
        res.data.result_code == "SUCCESS"
      ) {
        this.swift_data = res.data.resp_data;
        this.swift_data.pass_word = this.searchVlaue.split(":")[1];
      }
    },
    async modifySwift() {
      var data = {
        ...this.swift_data
      };
      data.pass_word = await this.$encrypt(
        this.$md5(data.pass_word).toUpperCase()
      );
      if (data.private_key) {
        data.private_key = await this.$encrypt(data.private_key);
      }
      if (data.md5 && data.md5.length == 32) {
        await this.$encrypt(data.md5);
      }
      const res = await swiftModify(data);
      if (this.testR(res) && res.data.resp_data.state == "OK") {
        this.successMessage("威富通账号修改成功！");
        this.$emit("swiftEmit", true);
      }
    },
    async saveSwiftConfigure() {
      var data = {
        ...this.swift_data
      };
      data.pass_word = await this.$encrypt(this.$md5(data.pass_word));
      if (data.private_key) {
        data.private_key = await this.$encrypt(data.private_key);
      }
      if (data.md5 && data.md5.length == 32) {
        await this.$encrypt(data.md5);
      }
      const res = await swiftConfigure(data);
      if (this.testR(res) && res.data.resp_data.state == "OK") {
        this.successMessage("威富通账号注册成功！");
        this.$emit("swiftEmit", true);
      }
      //
    }
  }
};
</script>
<style lang="less" scoped>
.title {
  // color: rgb(0, 89, 184);
  margin-bottom: 10px;
  // font-size: 24px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
}
.el-breadcrumb {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  padding-left: 20px;
  padding-top: 5px;
  margin-bottom: 0;
  font-size: 16px;
  z-index: 99;
}

.fa-morf {
  margin-top: 20px;
}

.right {
  width: 40%;
  min-width: 500px;
  float: left;
  padding-right: 10px;
}
.el-input {
  width: 250px;
}
.wty-footer {
  height: 60px;
  .el-button {
    width: 150px;
  }
}
</style>
